import { Auth } from "aws-amplify";
import { DateTime } from "luxon";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import api from "../../../utils/useApi";
import {
  TEXT_CONTACT_US,
  TEXT_DIDNT_RECIEVE_SMS,
  TEXT_IN_SECOND,
  TEXT_OR,
  TEXT_TRY_AGAIN,
} from "../../../utils/useConstants";
import { FunctionGetUsername } from "../../../utils/useFunction";
import { STYLE_LINK_BLUE, STYLE_TEXT_SMS } from "../../../utils/useStyle";

const LoginOtpAgain = ({ username, contry, value, otpReference }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const [count, setCount] = React.useState(30);
  const [canResend, setCanResend] = React.useState(false);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCount((count) => count - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    if (count === 0) {
      setCanResend(true);
    }
  }, [count]);

  return (
    <div className="pt-1 ">
      <div className={STYLE_TEXT_SMS(language)}>
        {TEXT_DIDNT_RECIEVE_SMS[language]}
      </div>
      <div className={`${STYLE_TEXT_SMS(language)}  `}>
        <span
          onClick={async () => {
            if (canResend) {
              const { data } = await api.post("/logs", {
                phone_number: `+${contry?.value}${value}`,
                day: DateTime.now().setLocale("th").setZone("UTC+7").toISO(),
              });

              if (data?.status) {
                setCount(30);
                setCanResend(false);
                await Auth.resendSignUp(FunctionGetUsername(username));

                otpReference.current[0].focus();
              } else {
                alert(
                  language === "TH"
                    ? "You have reached the OTP limit for today"
                    : "You have reached the OTP limit for today"
                );
              }
            }
          }}
          className={count > 0 ? ` mx-1 ` : `${STYLE_LINK_BLUE} `}
        >
          {count > 0 ? (
            <React.Fragment>
              {TEXT_TRY_AGAIN[language]}{" "}
              {TEXT_IN_SECOND[language]?.replace("[value]", count)}
            </React.Fragment>
          ) : (
            <React.Fragment>{TEXT_TRY_AGAIN[language]}</React.Fragment>
          )}
        </span>
        {TEXT_OR[language]}
        <span
          onClick={() => navigate("/ContactUs")}
          className={`${STYLE_LINK_BLUE}`}
        >
          {TEXT_CONTACT_US[language]}
        </span>
      </div>
    </div>
  );
};

export default LoginOtpAgain;
